import React, { useEffect, useState } from "react";
import { Flex, Text, Box, Container, Heading, Card, Callout } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

declare global {
    interface Window {
        google?: any;
    }
}

const AdminLogin: React.FC = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const handleCredentialResponse = async (response: any) => {
            try {
                const id_token = response.credential;

                const res = await fetch('/v1/auth/admin/session', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': id_token // The backend reads this to generate the JWT and set the cookie
                    }
                });

                if (res.ok) {
                    navigate('/admin');
                } else {
                    const data = await res.json();
                    setError(data.message || "Failed to authenticate");
                }
            } catch (err) {
                console.error(err);
                setError("An error occurred during authentication.");
            }
        };

        if (window.google) {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                callback: handleCredentialResponse
            });

            window.google.accounts.id.renderButton(
                document.getElementById("adminSignInDiv"),
                { theme: "outline", size: "large", type: "standard" }
            );
        }
    }, [navigate]);

    return (
        <Box style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Container size="1">
                <Card size="4" style={{ textAlign: 'center' }}>
                    <Flex direction="column" gap="4" align="center">
                        <Text size="8">
                            <Flex direction="row" justify="center" gap="1">
                                <Text weight="light">LiveFootball</Text>
                                <Text weight="bold">OnTV</Text>
                            </Flex>
                        </Text>
                        <Heading size="4" weight="regular" color="gray">Log In</Heading>

                        {error && (
                            <Callout.Root color="red">
                                <Callout.Text>You need admin access to go further</Callout.Text>
                            </Callout.Root>
                        )}

                        <Box mt="4">
                            <div id="adminSignInDiv"></div>
                        </Box>
                    </Flex>
                </Card>
            </Container>
        </Box>
    );
};

export default AdminLogin;
